import { Link } from "react-router-dom";

const PrivacyPolicy = () => (
  <>
    {/* Page Title Section */}
    <div className="wd-page-title page-title page-title-default title-size-default title-design-centered color-scheme-light">
      <div className="container">
        <h1 className="entry-title title">Privacy</h1>
        <nav className="wd-breadcrumbs">
          <span typeof="v:Breadcrumb">
            <Link to="/" rel="v:url" property="v:title">
              Home
            </Link>
          </span>
          <span className="wd-delimiter"></span>
          <span className="wd-last">Privacy</span>
        </nav>
      </div>
    </div>
    {/* Main Content Area for Privacy Policy */}
    <div className="wd-page-content main-page-wrapper">
      <h1 style={{ textAlign: "center", margin: "2rem" }}>
        Privacy
        <hr />
      </h1>
      <main
        className="wd-content-layout content-layout-wrapper container"
        role="main"
      >
        <p>
          Our Privacy Policy explains how we collect, use, and protect your
          personal information when you interact with our website and services.
          We are fully committed to safeguarding your data and ensuring your
          privacy. We collect personal information when you register on our
          site, place an order, subscribe to our newsletter, respond to a
          survey, fill out a form, or engage with our live chat support. The
          information you provide may be used to personalize your experience,
          enhance our website, improve customer service, process transactions,
          manage promotions or surveys, and send you periodic updates or emails.
          To protect your data, we use a range of security measures to ensure
          the safety and confidentiality of your personal information during
          submission, access, or transaction activities.
        </p>
        <hr style={{ border: "2px solid #9D0FA4" }} />
      
      </main>
    </div>
  </>
);

export default PrivacyPolicy;
